import {useEffect, useState} from "react";
import {deleteAdvertiser, getAllAdvertisers} from "../../API/api";
import BtngroupEditDelete from "../../components/btngroup-edit-delete";
import {Button} from "@mui/material";
import AddEditAdvertiser from "../../modules/add-edit-advertiser";
import styled from "styled-components";
import Pagination from "../../modules/pagination/pagination";
import {useSearchParams} from "react-router-dom";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const Th = styled.th`
  background: #007bff;
  color: white;
  padding: 10px;
  text-align: center;
  border-bottom: 2px solid #ddd;
  cursor: pointer;
`;

const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: ${(props) => props.align || "left"};
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background: #f2f2f2; /* Серый фон для чётных строк */
  }
`;

const Advertiser = () => {
    const [advertisers, setAdvertisers] = useState([]);
    const [dataAdvertiser, setDataAdvertiser] = useState(null);
    const [openAdvertiserModal, setOpenAdvertiserModal] = useState(false);
    const [searchParams] = useSearchParams();
    const [totalPage, setTotalPage] = useState('');

    // Sort, Filter, Pagination, search
    const [page, setPage] = useState(searchParams.get("page") || "1") ;
    const [limit, setLimit] = useState(searchParams.get("itemPerPage") || "10");
    const [sortBy, setSortBy] = useState('name');
    const [order, setOrder] = useState('ASC');
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('');

    useEffect(() => {
        setPage(searchParams.get("page"));
        setLimit(searchParams.get("itemPerPage"));
    }, [searchParams]);

    const getAdvertisers = async (params) => {
        const {data, total} = await getAllAdvertisers(
            localStorage.getItem("access_token"),
            params);
        setAdvertisers(data);
        setTotalPage(total);
    }
    useEffect(() => {
        let params = {}
        page && (params.page = page);
        limit && (params.limit = limit);
        sortBy && (params.sortBy = sortBy);
        order && (params.order = order);
        search && (params.search = search);
        sortBy && (params.sortBy = sortBy);
        filter && (params.filter = filter);

        getAdvertisers(params);
    },[openAdvertiserModal, sortBy, order, searchParams, page, limit]);

    const addAdvertiser = () => {
        setDataAdvertiser(null)
        setOpenAdvertiserModal(true)
    }

    const editAdvertiser = (data) => {
        setDataAdvertiser(data)
        setOpenAdvertiserModal(true)
    }

    const deleteAdvertiserBtn = async (id) => {
        try {
            await deleteAdvertiser(localStorage.getItem("access_token"), id)
            await getAdvertisers()
        } catch (error) {
        console.dir(error);
        throw new Error("Что-то не так с пост запросом");
        }
    }

    return (
        <div className="container" style={{padding: "30px"}}>
            <p>Рекламодатели:</p>
            <Button style={{width:280}} variant="contained" onClick={() => addAdvertiser()}>Добавить рекламодателя</Button>
          <Table>
            <thead>
              <tr>
                <Th
                    onClick={() => {
                        setSortBy("name");
                        setOrder(order === 'ASC' ? "DESC" : "ASC")
                    }}>Название</Th>
                <Th
                    onClick={() => {
                        setSortBy("video_price");
                        setOrder(order === 'ASC' ? "DESC" : "ASC")
                    }}>Стоимость ролик</Th>
                <Th
                    onClick={() => {
                        setSortBy("banner_price");
                        setOrder(order === 'ASC' ? "DESC" : "ASC")
                    }}>Стоимость Банера</Th>
                <Th
                    onClick={() => {
                        setSortBy("ticker_price");
                        setOrder(order === 'ASC' ? "DESC" : "ASC")
                    }}>Стоимость бегушка</Th>
                <Th>Управление</Th>
              </tr>
            </thead>
            <tbody>
              {advertisers.map((i) => {
                return (
                  <Tr key={i.id}>
                    <Td>{i.name}</Td>
                    <Td align={"center"}>{i.video_price}</Td>
                    <Td align={"center"}>{i.banner_price}</Td>
                    <Td align={"center"}>{i.ticker_price}</Td>
                    <Td align={"center"}>
                        <BtngroupEditDelete
                            editLink={() => editAdvertiser(i)}
                            deleteLink={() => deleteAdvertiserBtn(i.id)}
                        />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
            <Pagination items={totalPage} />

             {/* Модалка добавления и редактирования рекламодателя*/}
            <AddEditAdvertiser data={dataAdvertiser} setOpenAdvertiserModal={setOpenAdvertiserModal}
                         openAdvertiserModal={openAdvertiserModal} />
        </div>
    )
}

export default Advertiser;